import React from 'react'
import './MoreTalent.css'

import { Link } from 'react-router-dom';

const MoreTalent = ({prev,next}) => {

    return (
        <>
            <div className="more-talent">
                <div className="mt-left">
                    <Link to={prev['link']}>
                        <span>
                            <div className="mt-info">
                                <div className="mt-name">{prev['name']}</div>
                                <div className="mt-city">{prev['city']}</div>
                            </div><div className="mt-photo"
                                       style={{ backgroundImage:`url(${prev['photo']})`}}>
                            </div>
                        </span>
                    </Link>
                </div><div className="mt-right">
                    <Link to={next['link']}>
                        <span>
                            <div className="mt-photo"
                                style={{ backgroundImage:`url(${next['photo']})`}}>
                            </div><div className="mt-info">
                                <div className="mt-name">{next['name']}</div>
                                <div className="mt-city">{next['city']}</div>
                            </div>
                        </span>
                    </Link>
                </div>
            </div>
        </>
    )

}

export default MoreTalent;